import { CommonModule, registerLocaleData } from "@angular/common";
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr,
} from "@angular/common/http";
import localePt from "@angular/common/locales/pt";
import { LOCALE_ID, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import { MAT_DIALOG_DEFAULT_OPTIONS } from "@angular/material/dialog";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import {
  HttpInterceptorMiddleware,
  NgxEssentialsModule,
} from "@done/ngx-essentials";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import "moment/locale/pt";
import { CookieService } from "ngx-cookie-service";
import {
  NgxCurrencyInputMode,
  provideEnvironmentNgxCurrency,
} from "ngx-currency";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { environment } from "../../environments/environment";
import { LoadingComponent } from "./components/loading/loading.component";
import { getPaginatoriIntl } from "./mat-paginator-intl-pt";

const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: "DD/MM/YYYY",
  },

  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMMM YYYY",
    dateA11yLabel: "DD/MM/YYYY",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

registerLocaleData(localePt, "pt-Br");

@NgModule({
  declarations: [
    // Components
    LoadingComponent,
  ],
  imports: [
    // Modules
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEssentialsModule.forRoot({
      appWorkspaceUrl: environment.doneWorkspaceApp,
      apiGatewayUrl: environment.apiGateway,
      appName: environment.appName,
    }),

    //Pipes
    NgxMaskPipe,

    // Directives
    NgxMaskDirective,
  ],
  exports: [
    // Modules
    CommonModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxEssentialsModule,

    // Components
    LoadingComponent,

    //Pipes
    NgxMaskPipe,

    // Directives
    NgxMaskDirective,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorMiddleware,
      multi: true,
    },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 3000 } },
    { provide: MAT_DATE_LOCALE, useValue: "pt" },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
    { provide: LOCALE_ID, useValue: "pt" },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: "always" },
    },
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MatPaginatorIntl, useValue: getPaginatoriIntl() },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideNgxMask(),
    provideEnvironmentNgxCurrency({
      align: "right",
      allowNegative: false,
      allowZero: false,
      decimal: ",",
      precision: 2,
      prefix: "",
      suffix: "",
      thousands: ".",
      nullable: true,
      min: 0,
      inputMode: NgxCurrencyInputMode.Financial,
    }),
    CookieService,
  ],
})
export class SharedModule {}
